import React, { Dispatch, SetStateAction } from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { DesignCategories } from "@/db/designs";
import Image from "next/image";

interface DesignFilterProps{
    selectedCategory: string
    setSelectedCategory: Dispatch<SetStateAction<string>>;
}
const DesignFilter = ({
    selectedCategory,
    setSelectedCategory
}: DesignFilterProps) => {
  return (
    <ScrollArea className="w-[calc(100vw-1rem)] whitespace-nowrap">
      <div className="flex w-max gap-2">
        {DesignCategories.map((item, index) => (
          <button
            className={`flex flex-col mr-4 px-2 pb-2 py-1 items-center justify-center gap-1`}
            onClick={() => setSelectedCategory(item.title)}
            key={index}
          >
            <Image
              src={item.image}
              className="h-14 w-14 rounded-full object-cover"
              alt={item.title}
              width={56}
              height={56}
            />
            <p
              className={`font-semibold ${
                selectedCategory === item.title && "text-blue-500"
              }`}
            >
              {item.title}
            </p>
          </button>
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
};

export default DesignFilter;
